// import
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import axios from 'axios';
import CustomInput from "components/CustomInput/CustomInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import React from "react";
import Datetime from "react-datetime";
import { connect } from "react-redux";
import "react-table/react-table.css";
import { api_url } from 'redux/config.js';
import Toast from 'views/Toast/Toast';
import Analytical from "./ReportTypes/Analytical";
import Summary from "./ReportTypes/Summary";
import TextReports from "./ReportTypes/TextReports";
import AISummary from "./ReportTypes/AISummary";
import Participation from "./ReportTypes/Participation";
import { KpiCard, deltaText, MONO } from "./ReportTypes/ReportViz";
import Tour from "components/Tour/Tour";
import * as Score from "utils/Score";
import commonStyle from "assets/jss/common/common"
import moment from "moment";

import 'jspdf';
import 'jspdf-autotable';
import { withTranslation } from "react-i18next";
import { t } from "i18next";
// const

const styles = {
  ...commonStyle,
  ...regularFormsStyle,
  customInput: {
    paddingTop: 27,
    marginBottom: 17
  },
  // tighter spacing for the collapsible filter selects (the wide paddingTop above left big gaps)
  filterInput: {
    paddingTop: 6,
    marginBottom: 10
  },
  filterItem: {
    minWidth: 200,
    display: 'inline'
  }
};
// report_types keeps all 5 internal report kinds (renderReport indexes into it).
// The UI exposes 4 as tabs (Analytical / Summary / Text reports / AI summary);
// "Comparation" (index 3) is reached via Analytical + the "Compare periods" toggle.
const report_types = [
  { label: "Analytical", value: "Analytical" },
  { label: "Summary", value: "Summary" },
  { label: "Text reports", value: "Textreports" },
  { label: "Comparation", value: "Comparation" },
  { label: "AI summary", value: "AISummary" },
  { label: "Participation", value: "Participation" }
];
// tabs shown in the header, in order (index into report_types)
const TAB_TYPES = [report_types[0], report_types[1], report_types[2], report_types[5], report_types[4]];
// which report kinds support a 2nd period (everything except Text reports and Participation,
// whose columns ARE the dates)
const supportsCompare = (type) => type && type.value !== report_types[2].value && type.value !== report_types[5].value;

// Addresses reach us from three places with three different shapes — what the guest typed when
// answering, what a CSV/PMS import wrote into the contact list, and what the hotel typed by hand —
// so group matching has to compare them on equal terms rather than by raw string identity.
const normalizeEmail = (e) => String(e == null ? '' : e).trim().toLowerCase();

// Numbers reach us written in several ways (+30 694…, 0030694…, 694…), so they are compared by
// their digits with any leading zeros or country prefix stripped down to the last 9 — enough to
// identify a mobile without guessing at country rules.
const normalizePhoneKey = (p) => {
  const digits = String(p == null ? '' : p).replace(/\D/g, '');
  return digits ? digits.slice(-9) : '';
};

class ViewReportPage extends React.Component {
  constructor(props) {
    super(props);
    this.kpiRef = React.createRef();       // for Print: KPI header snapshot
    this.reportDomRef = React.createRef();  // for Print: rendered report DOM
    this.state = {
      id: this.props.match.params.survey_id,

      surveyMain: null,
      surveyQuestion: null,
      surveyResponses: null,

      report: null,
      alert: null,
      show: false,
      emaillist: [],
      showFilters: false,   // filters collapsed by default (progressive disclosure)
      tourOpen: false,      // guided walkthrough of the reports page
      kpis: null,           // header KPIs for period 1
      kpis2: null,          // header KPIs for period 2 (when comparing)
      filterData: {
        type: null,         // nothing selected until the user picks a tab
        compare: false,     // "Compare periods" toggle
        // response filtering
        from1: Date.now(),
        to1: Date.now(),
        from2: Date.now(),
        to2: Date.now(),
        group: [],

        // location filtering (rooms / tables / Σημεία)
        location: '',        // exact or comma-separated list
        locationFrom: '',    // numeric range start
        locationTo: '',      // numeric range end

        // question filtering
        section: null,
        question: null,
        answer: [],
      },
      filteredReseponseCount1: 0,
      filteredReseponseCount2: 0,
      reportRef: null
    };
  }
  componentDidMount() {
    this.onLoad()
  }

  // Reset only the filter fields (groups / section / question / answer / location).
  // Keeps the chosen report type, period and compare mode.
  onResetFilters = () => {
    let filterData = this.state.filterData;
    filterData.group = [];
    filterData.location = '';
    filterData.locationFrom = '';
    filterData.locationTo = '';
    filterData.section = null;
    filterData.question = null;
    filterData.answer = [];
    this.setState({ filterData })
  }

  setFilterData = (name, value) => {
    let filterData = this.state.filterData;
    filterData[name] = value
    this.setState({ filterData })
  }
  onLoad = () => {
    let self = this;
    const id = this.props.match.params.survey_id;
    const url = api_url + `survey/get`;
    const header = "Bearer ".concat(this.props.user.token);
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: "LOAD_START" });
    const ps_surveydata = axios({
      url, method: "get", params: { id: id }, headers: { authorization: "Bearer ".concat(this.props.user.token) }
    })

    const ps_emaillist = axios({ url: api_url + 'emaillist/all', method: 'get', headers: { authorization: "Bearer ".concat(this.props.user.token) } })

    Promise.all([ps_surveydata, ps_emaillist]).then(function (response) {
      const responses = response[0].data.data.responses || [];
      self.setState({
        surveyMain: response[0].data.data.main[0],
        surveyQuestion: response[0].data.data.questions[0],
        surveyResponses: responses,
        emaillist: response[1].data.data,
      }, () => {
        // Default period 1 to the LAST 30 DAYS — the range a hotelier actually reviews. The
        // pickers stay free for any other window; the header KPIs follow the same default so
        // they never disagree with the first report rendered.
        const fd = self.state.filterData;
        fd.from1 = moment().subtract(29, 'days').startOf('day').valueOf();
        fd.to1 = Date.now();
        fd.from2 = fd.from1;
        fd.to2 = fd.to1;
        const windowed = responses.filter(r => {
          const v = moment(r.created_at).valueOf();
          return v >= fd.from1 && v <= fd.to1;
        });
        self.setState({ filterData: fd, kpis: self.computeKpis(windowed), kpis2: null }, () => {
          // First visit → auto-start the walkthrough once (per browser).
          try {
            if (!window.localStorage.getItem('gq_tour_reports_v1')) {
              setTimeout(() => self.setState({ tourOpen: true }), 500);
            }
          } catch (e) { /* ignore */ }
        });
      });
      self.props.dispatch({ type: 'LOAD_END' });
    })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) {
          Toast(500);
          return;
        }
        Toast(errors.response.status);
      });
  };

  // Header KPIs for a set of responses: overall score (+ scale), response count, positive %.
  // Uses the same scoring helpers as the reports so the header never disagrees with the bars.
  computeKpis = (responses) => {
    const sq = this.state.surveyQuestion;
    const list = responses || [];
    if (!sq) return { score: 0, scale: 5, count: list.length, positivePct: 0 };
    let ssum = 0, scount = 0;
    list.forEach(r => {
      const s = Score.getScoreOfOneResponse(sq, r.answers || []);
      if (s > 0) { ssum += s; scount++; }
    });
    const score = scount ? ssum / scount : 0;
    let scale = 0, pos = 0, tot = 0;
    (sq.sections || []).forEach(sec => (sec.questions || []).forEach(q => {
      if (!q.question || q.question.type !== 'radio') return;
      const vals = (q.question.options || []).map(o => Number(o.value)).filter(v => !isNaN(v));
      if (!vals.length) return;
      const minV = Math.min.apply(null, vals), maxV = Math.max.apply(null, vals);
      if (maxV > scale) scale = maxV;
      const thr = Math.ceil((minV + maxV) / 2);
      list.forEach(r => {
        const a = (r.answers || []).filter(x => x.id === q.id)[0];
        if (a && a.value !== null && a.value !== undefined && a.value !== '') {
          const v = Number(a.value);
          if (!isNaN(v) && v > 0) { tot++; if (v >= thr) pos++; }
        }
      });
    }));
    if (!scale) scale = 5;
    return { score, scale, count: list.length, positivePct: tot ? Math.round(pos / tot * 100) : 0 };
  }

  // Integer / percentage-point delta chip (deltaText from ReportViz is 2-decimal, for scores).
  deltaSpan = (d, suffix) => {
    const up = d >= 0;
    return (
      <span style={{ fontFamily: MONO, fontSize: 12.5, fontWeight: 700, marginTop: 2, display: 'inline-block', color: up ? '#2f9e44' : '#d1495b' }}>
        {up ? '▲ +' : '▼ '}{d}{suffix || ''}
      </span>
    );
  }

  getOption = () => {
    const section = this.state.filterData.section
    const question = this.state.filterData.question
    const surveyResponses = this.state.surveyResponses
    if (!section || !question) return []
    const selectedQuestion = this.state.surveyQuestion.sections[section.value].questions[question.value]
    if (selectedQuestion.question.type === 'text') return []
    let answers = []
    const isCheckbox = selectedQuestion.question.type === 'checkbox'
    surveyResponses.forEach(response => {
      const answer = response.answers.filter(a => a.id === selectedQuestion.id)[0]
      if (!answer) return null;
      if (isCheckbox) {
        answers = answers.concat(answer.value)
      } else {
        answers.push(answer.value)
      }
    });
    const answers_unique = answers.filter((item, key) => answers.indexOf(item) === key)
    const opts = answers_unique.map(au => ({
      label: Score.getLabelOfAnswerValue(selectedQuestion, isCheckbox ? [au] : au),
      value: au
    }))
    // Rating answers best→worst (Excellent → Poor), i.e. highest value first.
    if (selectedQuestion.question.type === 'radio') {
      opts.sort((a, b) => Number(b.value) - Number(a.value))
    }
    return opts
  }
  getQuestionList = () => {
    const section = this.state.filterData.section
    if (!section) return []
    const questions = this.state.surveyQuestion.sections[section.value].questions
    if (!questions) return []

    const options = questions.map((item, question_index) => {
      return {
        label: item.questionTitle,
        value: question_index
      }
    })
    return options
  }

  // The identifiers of everyone in the selected groups. A phone list identifies its recipients by
  // number, and an SMS respondent's answer carries that number instead of an address, so both are
  // collected and compared the same way — otherwise selecting a phone list could never match
  // anything and the report would look empty for a whole channel.
  getEmailsFromGroup = (group) => {

    const emaillist = this.state.emaillist
    var keys = [];
    emaillist.forEach(elist => {
      const existIndex = group.findIndex(g => g.value === elist.id)
      if (existIndex > -1) {
        (elist.emails || []).forEach(e => {
          if (e.email) keys.push(normalizeEmail(e.email));
          if (e.phone) keys.push(normalizePhoneKey(e.phone));
        });
      }
    });
    return keys.filter(Boolean);
  }

  // What a response can be matched by: its address, or — for an SMS respondent, who has none —
  // the number stored as its identifier.
  responseKeys = (item) => {
    const out = [];
    const em = normalizeEmail(item.email);
    if (em) out.push(em);
    const id = String(item.emailidpass || '').trim();
    if (id && id.indexOf('@') < 0) out.push(normalizePhoneKey(id));
    return out.filter(Boolean);
  }

  filterResponses = (date) => {
    let surveyResponses = this.state.surveyResponses
    const surveyQuestion = this.state.surveyQuestion
    // return surveyResponses
    const filterData = this.state.filterData;
    // Record what each filter stage removes, so an empty report can say WHICH filter emptied it
    // instead of just showing "no answers" everywhere (see renderFilterNotice).
    const trace = { start: surveyResponses.length, groupEmpty: false }
    if (filterData.group.length > 0) {
      const emails = this.getEmailsFromGroup(filterData.group)
      if (emails.length > 0) {
        // Match on a normalized identifier: responses arrive with the casing/whitespace the guest
        // typed, list entries with whatever the import produced, so a raw === comparison silently
        // dropped answers that do belong to the group. A response identified by neither an address
        // nor a number (a QR / location link) can never belong to a group — counted so we can
        // say so.
        const wanted = emails.reduce((m, e) => { m[e] = true; return m }, {})
        trace.noEmail = surveyResponses.filter(item => this.responseKeys(item).length === 0).length
        surveyResponses = surveyResponses.filter(item =>
          this.responseKeys(item).some(k => wanted[k] === true))
      } else {
        trace.groupEmpty = true   // group selected but it holds no identifiers ⇒ filter ignored
      }
      trace.afterGroup = surveyResponses.length
    }
    const from1_start_day = moment(filterData.from1).startOf('day')
    const to1_end_day = moment(filterData.to1).endOf('day')
    const from2_start_day = moment(filterData.from2).startOf('day')
    const to2_end_day = moment(filterData.to2).endOf('day')
    const datefiltered = surveyResponses.filter(item => {
      const response_date = moment(item.created_at).valueOf()

      if (date === 1) {
        return response_date >= from1_start_day.valueOf() && response_date <= to1_end_day.valueOf()
      } else {
        return response_date >= from2_start_day.valueOf() && response_date <= to2_end_day.valueOf()
      }
    })
    surveyResponses = datefiltered
    trace.afterDate = surveyResponses.length
    const { section, question, answer } = filterData
    const answerValues = answer.map((a => a.value))
    if (filterData.answer.length > 0) {
      const answerfiltered = surveyResponses.filter(item => {
        const question_id = surveyQuestion.sections[section.value].questions[question.value].id
        const question_type = surveyQuestion.sections[section.value].questions[question.value].question.type
        const response_answer = item.answers.filter(a => a.id === question_id)[0]
        if (response_answer) {
          if (question_type === 'checkbox') {
            const matchedAnswers = response_answer.value.filter(rav => {
              return answerValues.indexOf(rav) >= 0
            })
            return matchedAnswers.length > 0
          } else {
            return answerValues.indexOf(response_answer.value) >= 0
          }
        } else {
          return false
        }
      })
      surveyResponses = answerfiltered
      trace.afterAnswer = surveyResponses.length
    }
    // Location filter: exact/comma-list and/or numeric range (from–to). When both are
    // given, a response matches if it is in the list OR inside the range (union).
    const locList = (filterData.location || '').split(',').map(s => s.trim()).filter(Boolean)
    const lFrom = filterData.locationFrom !== '' && filterData.locationFrom != null ? parseInt(filterData.locationFrom, 10) : null
    const lTo = filterData.locationTo !== '' && filterData.locationTo != null ? parseInt(filterData.locationTo, 10) : null
    const hasRange = lFrom !== null || lTo !== null
    if (locList.length > 0 || hasRange) {
      surveyResponses = surveyResponses.filter(item => {
        const loc = (item.location || '').trim()
        if (!loc) return false
        if (locList.length > 0 && locList.indexOf(loc) >= 0) return true
        if (hasRange) {
          const n = parseInt(loc, 10)
          if (!isNaN(n) && (lFrom === null || n >= lFrom) && (lTo === null || n <= lTo)) return true
        }
        return false
      })
      trace.afterLocation = surveyResponses.length
    }
    if (date === 1) this.filterTrace = trace
    return surveyResponses
  }

  // When the filters leave nothing to show, say WHICH filter emptied the report. Without this the
  // page just prints "no answer" under every question and looks like the data is gone — the section
  // filter in particular never removes a response (it only narrows what is displayed), so an empty
  // report while a section is selected is always caused by one of the other filters.
  renderFilterNotice = () => {
    const tr = this.filterTrace
    if (!tr || !this.state.filterData.type) return null
    if (this.state.filteredReseponseCount1 > 0) {
      return tr.groupEmpty ? this.filterNoticeBox(
        t('The selected group has no recipients, so the group filter was ignored.')) : null
    }
    if (!tr.start) return null   // the survey genuinely has no responses at all

    let reason = t('Your filters exclude every response.')
    if (tr.afterGroup === 0) {
      reason = t('No response belongs to the selected group(s).')
      if (tr.noEmail) reason += ' ' + t('Answers from a QR / location link carry neither an email nor a phone, so a group can never match them.')
        + ' (' + tr.noEmail + '/' + tr.start + ')'
    } else if (tr.afterDate === 0) {
      reason = t('No response falls inside the selected period.')
    } else if (tr.afterAnswer === 0) {
      reason = t('No response has the selected answer.')
    } else if (tr.afterLocation === 0) {
      reason = t('No response matches the selected location (room / table).')
    }
    return this.filterNoticeBox(reason + '  ' + t('Survey has {n} response(s) in total.').replace('{n}', tr.start))
  }

  filterNoticeBox = (text) => (
    <div style={{
      background: '#fff8e1', border: '1px solid #f3e0a6', borderRadius: 8,
      padding: '10px 14px', margin: '0 0 14px', fontSize: 13, color: '#6b5a1e',
    }}>
      <span role="img" aria-label="warning">⚠️</span> {text}
    </div>
  )

  // Pick a report type (tab). Renders immediately using the current period.
  onSelectType = (type) => {
    const fd = this.state.filterData;
    fd.type = type;
    if (!supportsCompare(type)) fd.compare = false; // Text reports has no compare
    this.setState({ filterData: fd }, () => this.renderReport());
  }

  renderReport = () => {
    const type = this.state.filterData.type
    if (!type) { this.setState({ report: null, kpis: this.computeKpis(this.state.surveyResponses || []), kpis2: null }); return }

    const compare = this.state.filterData.compare && supportsCompare(type)
    const responses1 = this.filterResponses(1)
    const kpis = this.computeKpis(responses1)

    let responses2 = null, kpis2 = null
    if (compare) {
      responses2 = this.filterResponses(2)
      kpis2 = this.computeKpis(responses2)
    }

    const { surveyQuestion, surveyMain } = this.state
    const common = {
      onRef: (ref) => this.setState({ reportRef: ref }),
      surveyMain, time: Date.now(), filterData: this.state.filterData, surveyQuestion,
    }

    let report = null
    switch (type.value) {
      case report_types[0].value: // Analytical (with optional A/B compare)
        report = <Analytical {...common} surveyResponses={responses1}
          surveyResponses2={compare ? responses2 : []} compare={compare} />
        break;
      case report_types[1].value: // Summary
        report = <Summary {...common} surveyResponses={responses1} surveyResponses2={compare ? responses2 : []} />
        break;
      case report_types[2].value: // Text reports
        report = <TextReports {...common} survey_id={this.state.id} surveyResponses={responses1} />
        break;
      case report_types[4].value: // AI summary
        report = <AISummary {...common} survey_id={this.state.id} surveyResponses={responses1} surveyResponses2={compare ? responses2 : []} />
        break;
      case report_types[5].value: // Participation per Σημείο/day
        report = <Participation {...common} survey_id={this.state.id} surveyResponses={responses1} />
        break;
      default:
        break;
    }
    this.setState({
      report, kpis, kpis2,
      filteredReseponseCount1: responses1.length,
      filteredReseponseCount2: responses2 ? responses2.length : 0,
    })
  }

  generatePdf = () => {
    if (!this.state.reportRef) return
    const addon = 'Report'
    const date_ = moment().format('MMM_Do_YY')
    const type = this.state.filterData.type ? this.state.filterData.type.value : 'report'
    const fileName = `${addon}_${type}_${date_}.pdf`
    this.state.reportRef.generatePdf(fileName)
  }
  generateCSV = () => {
    if (!this.state.reportRef) return
    this.state.reportRef.generateCSV()
  }
  // Context-aware: exports whichever report is currently rendered (Analytical / Summary / Text).
  generateExcel = () => {
    if (!this.state.reportRef) return
    if (!this.state.reportRef.generateExcel) { Toast(400, t('Excel export is not available for this report')); return }
    const date_ = moment().format('MMM_Do_YY')
    const type = this.state.filterData.type ? this.state.filterData.type.value : 'report'
    this.state.reportRef.generateExcel(`Report_${type}_${date_}.xlsx`)
  }
  // Print the rendered report. The modern reports use inline styles, so cloning the report DOM
  // into a blank window prints faithfully — window.print() on the SPA came out blank because the
  // report lives inside the dashboard's fixed-height scroll container.
  printReport = () => {
    const { surveyMain, filterData, kpis } = this.state
    // A report may provide compact, self-contained print HTML (Text reports do, to avoid printing
    // the heavy MUI accordion DOM). Otherwise clone the rendered, inline-styled report DOM.
    const ref = this.state.reportRef
    const custom = ref && typeof ref.getPrintHtml === 'function' ? ref.getPrintHtml() : null
    const repHtml = custom != null ? custom : (this.reportDomRef && this.reportDomRef.current ? this.reportDomRef.current.innerHTML : '')
    if (!repHtml) { Toast(400, t('Choose a report type above to begin')); return }
    const period1 = moment(filterData.from1).format('LL') + ' – ' + moment(filterData.to1).format('LL')
    const comparing = filterData.compare && supportsCompare(filterData.type)
    const period2 = moment(filterData.from2).format('LL') + ' – ' + moment(filterData.to2).format('LL')
    const kp = kpis || {}
    const kpiLine = kp.count != null
      ? (t('Overall score') + ': ' + Number(kp.score || 0).toFixed(2) + '/' + kp.scale +
        '   ·   ' + t('Responses') + ': ' + kp.count +
        '   ·   ' + t('Positive') + ': ' + kp.positivePct + '%')
      : ''
    const w = window.open('', '_blank', 'width=1000,height=800')
    if (!w) { Toast(400, 'Popup blocked'); return }
    w.document.open()
    w.document.write(
      '<!doctype html><html lang="' + ((typeof document !== 'undefined' && document.documentElement.lang) || 'en') + '"><head><meta charset="utf-8"><title>' + (surveyMain.title || 'Report') + '</title>' +
      '<style>body{font-family:ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,Arial,sans-serif;margin:24px;color:#1b2320;}' +
      'h2{margin:0 0 4px;font-size:20px;} .sub{color:#8a988f;font-size:13px;margin:0 0 6px;}' +
      '.kpiline{font-size:13px;font-weight:600;color:#2f8a45;margin:0 0 18px;}' +
      // Text reports use MUI Accordions: without MUI CSS the SVG expand icon renders huge and the
      // answer panels stay collapsed. Constrain icons, hide inputs, and force the panels open.
      'svg{width:18px!important;height:18px!important;vertical-align:middle;}' +
      'input,button,textarea{display:none!important;}' +
      '[class*="MuiCollapse"]{height:auto!important;min-height:0!important;overflow:visible!important;visibility:visible!important;}' +
      '[class*="MuiAccordion"]{box-shadow:none!important;border:1px solid #e2e8e4!important;margin:0 0 8px!important;}' +
      '@media print{@page{margin:12mm;}}</style>' +
      '</head><body>' +
      '<h2>' + (surveyMain.title || '') + '</h2>' +
      '<div class="sub">' + period1 + (comparing ? '  ·  vs ' + period2 : '') + '</div>' +
      (kpiLine ? '<div class="kpiline">' + kpiLine + '</div>' : '') +
      repHtml +
      '</body></html>'
    )
    w.document.close()
    w.focus()
    setTimeout(function () { try { w.print() } catch (e) { } }, 500)
  }

  // ---- guided walkthrough ----

  openTour = () => this.setState({ tourOpen: true });
  closeTour = () => {
    try { window.localStorage.setItem('gq_tour_reports_v1', '1'); } catch (e) { /* ignore */ }
    this.setState({ tourOpen: false });
  };
  getTourSteps = () => ([
    {
      selector: '[data-tour="kpis"]', placement: 'bottom',
      title: t('Summary cards'),
      body: t('The key numbers at a glance — overall score, responses and positive %. In compare mode they also show the change (Δ).'),
    },
    {
      selector: '[data-tour="tabs"]', placement: 'bottom',
      title: t('Choose a report type'),
      body: t('Pick a tab: Analytical, Summary, Text reports or AI summary. Nothing is selected until you choose one.'),
    },
    {
      selector: '[data-tour="period"]', placement: 'bottom',
      action: () => this.onSelectType(report_types[0]),
      title: t('Choose the period'),
      body: t('Once you pick a type, set the date range you want to see here.'),
    },
    {
      selector: '[data-tour="filters"]', placement: 'bottom',
      action: () => this.setState({ showFilters: true }),
      title: t('Filters'),
      body: t('Open Filters to narrow by group, section, question, answer or location (room / table).'),
    },
    {
      selector: '[data-tour="compare"]', placement: 'top',
      title: t('Compare periods'),
      body: t('Turn this on to reveal a second period and compare two date ranges side by side.'),
    },
    {
      selector: '[data-tour="apply"]', placement: 'top',
      title: t('Show results'),
      body: t('Press this to render the report below with your chosen period and filters.'),
    },
    {
      selector: '[data-tour="export"]', placement: 'bottom',
      title: t('Export & Print'),
      body: t('Print, PDF, Excel or CSV — each acts on whichever report you are currently viewing.'),
    },
  ]);

  // ---- render helpers ----

  renderTabs = () => {
    const { filterData } = this.state
    return (
      <div>
      <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.09em', color: '#8a988f', fontWeight: 700, margin: '2px 2px 6px' }}>
        {t('Choose a report type')}
      </div>
      <div data-tour="tabs" style={{ display: 'flex', gap: 4, borderBottom: '1px solid #e2e8e4', margin: '0 0 22px', flexWrap: 'wrap' }}>
        {TAB_TYPES.map(type => {
          const active = filterData.type && filterData.type.value === type.value
          const label = type.value === report_types[4].value ? '✨ ' + t(type.label) : t(type.label)
          return (
            <button key={type.value} onClick={() => this.onSelectType(type)}
              style={{
                appearance: 'none', border: 0, background: 'transparent', fontFamily: 'inherit',
                fontSize: 14, fontWeight: 600, color: active ? '#1b2320' : '#5d6d66', padding: '10px 16px',
                cursor: 'pointer', borderBottom: active ? '2px solid #2f9e44' : '2px solid transparent', marginBottom: -1,
              }}>
              {label}
            </button>
          )
        })}
      </div>
      </div>
    )
  }

  renderKpis = () => {
    const { surveyQuestion, filterData } = this.state
    const kp = this.state.kpis || { score: 0, scale: 5, count: 0, positivePct: 0 }
    const kp2 = this.state.kpis2
    const cmp = filterData.compare && kp2 && supportsCompare(filterData.type)
    return (
      <GridContainer>
        <GridItem xs={6} md={3}>
          <KpiCard label={t('Overall score')} value={kp.score.toFixed(2)} unit={'/' + kp.scale}
            delta={cmp ? deltaText(kp.score, kp2.score) : null}
            meterPct={kp.scale ? Math.round(kp.score / kp.scale * 100) : 0} />
        </GridItem>
        <GridItem xs={6} md={3}>
          <KpiCard label={t('Responses')} value={kp.count}
            delta={cmp ? this.deltaSpan(kp.count - kp2.count) : null} />
        </GridItem>
        <GridItem xs={6} md={3}>
          <KpiCard label={t('Positive')} value={kp.positivePct} unit={'%'}
            delta={cmp ? this.deltaSpan(kp.positivePct - kp2.positivePct, ' pts') : null}
            meterPct={kp.positivePct} />
        </GridItem>
        <GridItem xs={6} md={3}>
          <KpiCard label={t('Sections')} value={surveyQuestion.sections.length} />
        </GridItem>
      </GridContainer>
    )
  }

  renderControls = () => {
    const { classes } = this.props
    const { filterData, showFilters, surveyQuestion, emaillist } = this.state
    const options = this.getOption()
    const cardStyle = {
      background: '#fff', border: '1px solid #e2e8e4', borderRadius: 14,
      boxShadow: '0 1px 2px rgba(20,40,30,.06),0 6px 20px rgba(20,40,30,.05)', marginBottom: 16, padding: '16px 18px',
    }
    if (!filterData.type) {
      return (
        <div style={{ fontSize: 13.5, color: '#5d6d66', padding: '16px 18px', border: '1px dashed #cfd8d3', borderRadius: 12, marginBottom: 16 }}>
          ℹ️ {t('Choose a report type above to begin')}
        </div>
      )
    }
    const canCompare = supportsCompare(filterData.type)
    return (
      <div style={cardStyle}>
        {/* Period 1 */}
        <div data-tour="period">
        <GridContainer>
          <GridItem xs={12} md={3}>
            <FormLabel className={classes.labelHorizontal}>{t('Choose period:')}</FormLabel>
          </GridItem>
          <GridItem xs={12} md={4}>
            <FormControl fullWidth>
              <Datetime closeOnSelect={true} onChange={(m) => this.setFilterData('from1', m.valueOf())}
                className={classes.customInput} timeFormat={false} value={filterData.from1}
                inputProps={{ placeholder: t('From') }} dateFormat="DD/MM/YYYY" />
            </FormControl>
          </GridItem>
          <GridItem xs={12} md={4}>
            <FormControl fullWidth>
              <Datetime closeOnSelect={true} onChange={(m) => this.setFilterData('to1', m.valueOf())}
                className={classes.customInput} value={filterData.to1} timeFormat={false}
                dateFormat="DD/MM/YYYY" inputProps={{ placeholder: t('To') }} />
            </FormControl>
          </GridItem>
        </GridContainer>
        </div>

        {/* Compare toggle */}
        {canCompare &&
          <label data-tour="compare" style={{ display: 'inline-flex', alignItems: 'center', gap: 9, cursor: 'pointer', fontWeight: 600, color: '#5d6d66', fontSize: 13.5, margin: '4px 0 6px' }}>
            <input type="checkbox" checked={!!filterData.compare}
              onChange={(e) => { this.setFilterData('compare', e.target.checked); this.renderReport(); }} />
            {t('Compare periods')}
          </label>
        }

        {/* Period 2 (only when comparing) */}
        {canCompare && filterData.compare &&
          <GridContainer>
            <GridItem xs={12} md={3}>
              <FormLabel className={classes.labelHorizontal}>{t('Choose Period 2th*:')}</FormLabel>
            </GridItem>
            <GridItem xs={12} md={4}>
              <FormControl fullWidth>
                <Datetime closeOnSelect={true} onChange={(m) => this.setFilterData('from2', m.valueOf())}
                  value={filterData.from2} className={classes.customInput} timeFormat={false}
                  dateFormat="DD/MM/YYYY" inputProps={{ placeholder: t('From') }} />
              </FormControl>
            </GridItem>
            <GridItem xs={12} md={4}>
              <FormControl fullWidth>
                <Datetime closeOnSelect={true} onChange={(m) => this.setFilterData('to2', m.valueOf())}
                  value={filterData.to2} className={classes.customInput} timeFormat={false}
                  dateFormat="DD/MM/YYYY" inputProps={{ placeholder: t('To') }} />
              </FormControl>
            </GridItem>
          </GridContainer>
        }

        {/* Filters toggle */}
        <div data-tour="filters" style={{ marginTop: 6 }}>
          <Button color={showFilters ? 'success' : 'white'} size="sm"
            onClick={() => this.setState({ showFilters: !showFilters })}>
            {showFilters ? t('Hide filters') : t('Filters')}
          </Button>
        </div>

        {/* Collapsible filters */}
        {showFilters &&
          <GridContainer style={{ marginTop: 8 }}>
            <GridItem xs={12} md={3}>
              <FormLabel className={classes.labelHorizontal}>{t('Choose groups(contact):')}</FormLabel>
            </GridItem>
            <GridItem xs={12} md={9}>
              <CustomSelect isMulti={true} className={classes.filterInput}
                onChange={elist => { this.setFilterData('group', elist) }} value={filterData.group}
                placeholder={t('Groups')} options={emaillist.map((item) => ({ value: item.id, label: item.name }))} />
            </GridItem>
            <GridItem xs={12} md={3}>
              <FormLabel className={classes.labelHorizontal}>{t('Choose section:')}</FormLabel>
            </GridItem>
            <GridItem xs={12} md={9}>
              <CustomSelect className={classes.filterInput}
                onChange={section => {
                  this.setFilterData('question', null)
                  this.setFilterData('answer', [])
                  this.setFilterData('section', section)
                }}
                value={filterData.section} placeholder={t('Section')}
                options={surveyQuestion.sections.map((item, sectionIndex) => ({ label: item.sectionTitle, value: sectionIndex }))} />
            </GridItem>
            <GridItem xs={12} md={3}>
              <FormLabel className={classes.labelHorizontal}>{t('Choose question:')}</FormLabel>
            </GridItem>
            <GridItem xs={12} md={9}>
              <CustomSelect className={classes.filterInput}
                onChange={question => { this.setFilterData('answer', []); this.setFilterData('question', question) }}
                placeholder="Question" value={filterData.question} options={this.getQuestionList()} />
            </GridItem>
            <GridItem xs={12} md={3}>
              <FormLabel className={classes.labelHorizontal}>{t('Answer:')}</FormLabel>
            </GridItem>
            <GridItem xs={12} md={9}>
              <CustomSelect isMulti className={classes.filterInput}
                onChange={answers => { this.setFilterData('answer', answers) }}
                placeholder={t('Question')} value={filterData.answer} options={options} />
            </GridItem>
            <GridItem xs={12} md={3}>
              <FormLabel className={classes.labelHorizontal}>{t('Location (room / table):')}</FormLabel>
            </GridItem>
            <GridItem xs={12} md={3}>
              <CustomInput labelText={t('Exact / list (e.g. 205, 210)')} id="filterLocation"
                formControlProps={{ fullWidth: true }}
                inputProps={{ type: 'text', value: filterData.location, onChange: (e) => this.setFilterData('location', e.target.value) }} />
            </GridItem>
            <GridItem xs={6} md={3}>
              <CustomInput labelText={t('Range from')} id="filterLocationFrom"
                formControlProps={{ fullWidth: true }}
                inputProps={{ type: 'number', value: filterData.locationFrom, onChange: (e) => this.setFilterData('locationFrom', e.target.value) }} />
            </GridItem>
            <GridItem xs={6} md={3}>
              <CustomInput labelText={t('Range to')} id="filterLocationTo"
                formControlProps={{ fullWidth: true }}
                inputProps={{ type: 'number', value: filterData.locationTo, onChange: (e) => this.setFilterData('locationTo', e.target.value) }} />
            </GridItem>
            <GridItem>
              <Button color='danger' size="sm" onClick={this.onResetFilters}>{t('Reset Filters')}</Button>
            </GridItem>
          </GridContainer>
        }

        {/* Apply */}
        <div data-tour="apply" style={{ marginTop: 10 }}>
          <Button color="success" onClick={() => this.renderReport()}>{t('Show results')}</Button>
        </div>
      </div>
    )
  }

  render() {
    const { surveyMain, surveyQuestion, filterData } = this.state
    if (!surveyMain) return '...';

    const kp = this.state.kpis || { count: 0 }
    const period1 = moment(filterData.from1).format('LL') + ' – ' + moment(filterData.to1).format('LL')
    const period2 = moment(filterData.from2).format('LL') + ' – ' + moment(filterData.to2).format('LL')
    const comparing = filterData.compare && supportsCompare(filterData.type)

    const btnStyle = {
      fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600, border: '1px solid #cfd8d3', background: '#fff',
      color: '#5d6d66', borderRadius: 8, padding: '7px 12px', cursor: 'pointer', marginLeft: 8,
    }

    return (
      <div>
        {this.state.alert}

        {/* Header: brand + title + subtitle + export toolbar */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 16, flexWrap: 'wrap', margin: '4px 2px 20px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 700, fontSize: 16, color: '#2f8a45' }}>
              <span style={{ width: 12, height: 12, borderRadius: 3, background: '#2f9e44', display: 'inline-block' }} />
              GooQuest
            </div>
            <h3 style={{ fontSize: 22, margin: '4px 0 3px', letterSpacing: '-.02em', color: '#1b2320', fontWeight: 700 }}>{surveyMain.title}</h3>
            <div style={{ color: '#8a988f', fontSize: 13 }}>
              {period1} · {kp.count} {t('Responses')}{comparing ? ' · vs ' + period2 : ''}
            </div>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <button style={btnStyle} onClick={this.openTour}>🧭 {t('Tour')}</button>
            <span data-tour="export" style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
              <button style={btnStyle} onClick={this.printReport}>🖨 {t('Print')}</button>
              <button style={btnStyle} onClick={this.generatePdf}>⤓ {t('PDF')}</button>
              <button style={btnStyle} onClick={this.generateExcel}>⤓ {t('Excel')}</button>
              <button style={btnStyle} onClick={this.generateCSV}>⤓ {t('CSV')}</button>
            </span>
          </div>
        </div>

        {/* KPI cards */}
        <div ref={this.kpiRef} data-tour="kpis">{this.renderKpis()}</div>

        {/* Report-type tabs */}
        {this.renderTabs()}

        {/* Period + filters + compare controls */}
        {this.renderControls()}

        {/* The rendered report */}
        <GridContainer>
          <GridItem xs={12} md={12}>
            {this.renderFilterNotice()}
            <div ref={this.reportDomRef}>{this.state.report}</div>
          </GridItem>
        </GridContainer>

        <Tour open={this.state.tourOpen} steps={this.getTourSteps()} onClose={this.closeTour} />
      </div>
    );
  }
}


const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(ViewReportPage)));
